import { styled } from '@mui/material';
import Input from '@mui/material/Input';

export const StyledLabel = styled('label')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50%',
    height: '100px',
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: '#f0f0f0',
    '&:hover': {
        transform: 'scale(1.05)',
    },
});

export const StyledInput = styled(Input)({
    display: 'none',
});